import { Input, AfterViewInit, OnDestroy, Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { FeesObject, FieldValueModel, ProductExtraInfos } from "../public-website/buyer/buyer";
import ConstantFees from "./constantFees";
import paymentOptionsConstant from './paymentOptionsConstant';
import { CurrencyExchangeService } from "./services/currency-exchange.service";
import { AuthService } from "./services/auth.service";
import { ViewProductInfoHandlerService } from "../public-website/buyer/services/view-product-info-handler.service";
import { GetBusinessProfileService } from "./services/get-business-profile.service";
import { GetCalculatesParamsService } from "../public-website/buyer/services/get-calculates-params.service";

@Injectable({
  providedIn: 'root'
})

export abstract class BaseTemplate implements AfterViewInit, OnDestroy {
  subscriptions: Subscription[] = [];
  @Input() productObject: any;
  @Input() businessObject: any;
  @Input() productId: any;
  @Input() ProductTypeId: any;
  @Input() Tickets?: any;
  @Input() Slots?: any;
  @Input() expired: boolean = false;
  quantity: number = 1;
  price = 0;
  packagePrice = 0;
  taxes = 0;
  subtotal = 0;
  total = 0;
  dicountValue = 0;
  feesArray: Array<FeesObject> = [];
  totalFees = 0;
  exchangeRates: object[] = [];
  extrasObject: any;

  constructor(
    public vpihs: ViewProductInfoHandlerService,
    public getBusinessProfileService: GetBusinessProfileService,
    public auth: AuthService,
    public exchangeService: CurrencyExchangeService,
    public getCalculatesParamsService: GetCalculatesParamsService
  ) { }

  getProductValueByFieldName(
    _fieldName: string,
    _productFieldValues = this.productObject
  ): any {}

  protected async initCurrencies() {
    this.exchangeRates = await this.exchangeService.make();
  }

  public getExchangeRateToEGP(currency: string) {
    if (currency === "EGP") {
      return 1;
    } else {
      return this.exchangeRates.reduce((prev, current: any) => {
        if ((current.name as string).includes(currency)) {
          return current.rate;
        }
        return prev;
      }, 1);
    }
  }

  public getExchangedValue(
    egpValue: number,
    currency: string,
    map: boolean = true
  ): number {
    if (!map) return +egpValue;

    return +(egpValue / this.getExchangeRateToEGP(currency));
  }

  handlePackagePrice(packageList: any) {
    if (this.vpihs.currency !== 'EGP') {
      const newPackageList: any[] = [];
      packageList.map((p: any) => {
        p.USD = this.getExchangedValue(p.price, this.vpihs.currency).toFixed(2);
        newPackageList.push(p)
      })
      return newPackageList;
    } else {
      return packageList;
    }
  }

  getProductValueByFieldTypeName(
    fieldTypeName: string,
    productFieldValues = this.productObject
  ): any {
    const allFields: Array<FieldValueModel> = productFieldValues;
    if (this.productObject.ProductType.name == "Physical Product") {
      return this.getNewProductValueByFieldName(fieldTypeName, 'ProductExtraInfos');
    }
    else {
      for (const fieldValue of allFields) {
        if (fieldValue.Field?.FieldType?.name === fieldTypeName) {
          if (fieldTypeName === 'productPrice') {
            // handle converstion when currency is not EGP
            if (this.vpihs.currency !== 'EGP' && fieldValue.fieldValue) {
              const result = this.getExchangedValue(+fieldValue.fieldValue, this.vpihs.currency);
              return result;
            }
          }
          return fieldValue.fieldValue;
        }
      }
    }
    return undefined;
  }
  calculateTaxes() {
    const taxes = this.getNewProductValueByFieldName("taxes", "ProductTax");
    const type = this.getNewProductValueByFieldName("type", "ProductTax");
    if (!taxes) {
      this.taxes = 0;
      return this.taxes;
    }
    let taxesValue = 0;
    if (type && type === "Percentage") {
      const taxesObjectValue = Number(taxes) || 0;
      taxesValue = (this.subtotal * taxesObjectValue) / 100;
    } else {
      taxesValue = this.getExchangedValue(Number(taxes), this.vpihs.currency);
    }
    return (this.taxes = taxesValue);
  }

  async commitChanges() {
    if (this.productObject.ProductType.name == "Quick Payment") {
      this.vpihs.currency = this.productObject['QuickPaymentExtraInfos'][0].currency;
    }
    await this.initCurrencies()
    this.vpihs.setViewInfoObject({
      product: this.productObject,
      extras: this.extrasObject,
      business: this.productObject.Business
    });
    this.vpihs.BusinessId = this.productObject.BusinessId;
    this.getCalculatesParamsService.setQuantity(this.quantity);
    await this.getCalculatesParamsService.calculateInfos();
    this.vpihs.quantity = this.quantity;
  }

  ngAfterViewInit() {
    this.vpihs.productId = this.productId;
    let currency;
    if (this.productObject.ProductType.name == "Quick Payment") {
      currency = this.productObject['QuickPaymentExtraInfos'][0].currency;
    } else {
      currency = this.getNewProductValueByFieldName("currency", "ProductExtraInfos");
    }
    this.vpihs.currency = currency
      ? currency
      : "EGP";
    this.vpihs.taxes = this.taxes;
    this.subscriptions.push(
      this.vpihs.promoDiscount.subscribe(() => {
        this.commitChanges();
      })
    );
    this.subscriptions.push(
      this.vpihs.paymentOptionObjectEmitter.subscribe(() => {})
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  calculateDiscount() {
    if (this.vpihs.promoDiscount.value === 100) {
      this.dicountValue = -(this.subtotal + this.taxes + this.totalFees);
      return this.dicountValue;
    }
    const percentageValue = this.vpihs.promoDiscount.value;
    const absoluteDiscountValue = (this.subtotal * percentageValue) / 100;
    const actualDisountValue = -absoluteDiscountValue;
    return (this.dicountValue = actualDisountValue);
  }
  calculateSubTotalAmount(): number {
    return 0;
  }
  getProductPrice(): number {
    let subtotal;
    if (!this.calculateSubTotalAmount()) {
      subtotal = this.vpihs.getExchangedValue(this.subtotal, this.vpihs.currency)
      subtotal += Number(this.calculateSubTotalAmount());
      return subtotal;
    }
    //make default value for subtotla with product price;
    subtotal = Number(this.calculateSubTotalAmount());
    return subtotal;
  }

  calculateTotalAmount() {
    let total = 0;
    let subtotal = Number(this.getProductPrice()) || 0;
    this.subtotal = subtotal;
    const taxes = this.getExchangedValue(Number(this.calculateTaxes()), this.vpihs.currency) || 0;
    const fees = this.getFees() || 0;

    const discount = this.getExchangedValue(Number(this.calculateDiscount()), this.vpihs.currency) || 0;
    total = Number(subtotal) + Number(taxes) + Number(fees) + Number(discount);
    this.total = Number(total);
    this.subtotal = subtotal;
    this.vpihs.subTotal = this.subtotal = this.vpihs.getExchangedValue(this.subtotal, this.vpihs.currency)
    return this.total;
  }

  getFeesFromSeller(): FeesObject | null {
    const feesStringValue = this.getNewProductValueByFieldName('feesOnBuyerFlag', 'ProductExtraInfos');
    let netFees = 0;
    // console.log("out if")
    if (feesStringValue === "true" || feesStringValue === "1") {
      const feesValue = this.businessObject.fees;
      // console.log("in if")
      const feesType = this.businessObject.fees_type;
      if (feesType === "Percentage") {
        let amount = this.quantity * this.getProductValueByFieldName('Product price');
        if (this.dicountValue < -0) {
          let discount;
          if (this.vpihs.currency != 'EGP') {
            discount = +(this.dicountValue * this.getExchangeRateToEGP(this.vpihs.currency)) || 0;
          }
          else {
            discount = +this.dicountValue || 0;
          }
          netFees = ((amount - Math.abs(discount)) + this.vpihs.taxes) * (Number(feesValue) / 100);
        }
        else {
          netFees = ((amount + this.vpihs.taxes) * Number(feesValue)) / 100;
        }
        console.log("netFees", netFees)
      } else {
        netFees = feesValue;
      }
      const feesObject = {
        name: "Buyer Fees",
        value: this.vpihs.getExchangedValue(netFees, this.vpihs.currency)
      };
      return feesObject;
    } else {
      return null;
    }
  }

  getFees(): number {
    this.feesArray = [];
    const sellerFees = this.getFeesFromSeller();
    if (sellerFees) {
      this.feesArray.push(sellerFees);
    }
    let totalFees = 0;
    if (
      this.vpihs.paymentOptionObject.selection === paymentOptionsConstant.constantPaymentOptions.value.CREDIT_CARD ||
      this.ProductTypeId === 4 ||
      this.vpihs.paymentOptionObject.selection === paymentOptionsConstant.constantPaymentOptions.value.Mobile_Wallet ||
      this.vpihs.paymentOptionObject.selection === paymentOptionsConstant.constantPaymentOptions.value.MEEZA
    ) {
      let creditCardFees = Object.assign({}, ConstantFees.creditCardFees);
      creditCardFees.value = Number(this.vpihs.getExchangedValue(Number(creditCardFees.value), this.vpihs.currency))
      this.feesArray.push(creditCardFees as FeesObject);
      this.totalFees += creditCardFees.value
    }

    if (this.vpihs.paymentOptionObject.selection === paymentOptionsConstant.constantPaymentOptions.value.CASH) {
      let cashFees = Object.assign({}, ConstantFees.cashFees);
      cashFees.value = Number(this.vpihs.getExchangedValue(Number(cashFees.value), this.vpihs.currency))
      this.feesArray.push(cashFees as FeesObject);
      this.totalFees += cashFees.value
    }

    for (const fee of this.feesArray) {
      totalFees += fee.value;
    }

    this.totalFees = totalFees;
    this.vpihs.fees = totalFees;
    this.vpihs.setFeesObjectArray(JSON.parse(JSON.stringify(this.feesArray)));
    return this.totalFees;
  }

  async ifSeller() {
    const businessData = await this.auth.getBusiness();
    let productsBusinessID;
    let businessID;
    if (this.productObject && this.businessObject) {
      productsBusinessID = this.businessObject.id;
    }

    if (businessData) {
      businessID = businessData.id;
    }

    return productsBusinessID === businessID;
  }

  getNewProductValueByFieldName(fieldName: any, productFieldValues = 'ProductExtraInfos') {
    if (productFieldValues == 'ProductExtraInfos') {
      const allFields: ProductExtraInfos[] = this.productObject.ProductExtraInfos;
      for (const field of allFields) {
        if (field.key === fieldName) {
          return field.value;
        }
      }
    } else {
      const allFields = this.productObject[productFieldValues];
      if (allFields) {
        for (const key of Object.keys(allFields)) {
          if (key === fieldName) {
            if (fieldName === 'price') {
              // handle converstion when currency is not EGP
              if (this.vpihs.currency !== 'EGP') {
                const result = this.getExchangedValue(+allFields[key], this.vpihs.currency);
                return result;
              }
            }
            return allFields[key];
          }
        }
      }
    }
    return undefined;
  }

}
